import {createContext, useContext, useEffect, useState} from 'react';
import {useAuth} from '@/context/AuthContext';
import {api} from '@/lib/api';
import {workspaceText as tr} from '@/i18n/workspaceCopy';

const empty = {items: [], loading: true, error: false};
const ArtistTasksContext = createContext(empty);
export const useArtistTasks = () => useContext(ArtistTasksContext);

export function ArtistTasksProvider({children}) {
  const {workspace, user, studio} = useAuth();
  const scope = workspace?.role === 'artist' ? `${studio?.id}:${user?.id}:${workspace.artist_profile_id}` : null;
  const [state, setState] = useState({...empty, scope: null});
  useEffect(() => {
    if (!scope) return undefined;
    let active = true, generation = 0;
    const refresh = async () => {
      if (document.visibilityState === 'hidden') return;
      const current = ++generation;
      try {
        let offset = 0, items = [];
        do {
          const page = await api.get(`/professional-materials/pending-sessions?offset=${offset}`);
          if (!active || current !== generation) return;
          if (!Array.isArray(page.items)) throw new Error('Invalid task response');
          items.push(...page.items);
          offset = page.next_offset;
        } while (offset != null);
        setState({scope, items, loading: false, error: false});
      } catch {
        if (active && current === generation) setState(old => ({...(old.scope === scope ? old : empty), scope, loading: false, error: true}));
      }
    };
    refresh();
    window.addEventListener('focus', refresh);
    window.addEventListener('tps:data-changed', refresh);
    document.addEventListener('visibilitychange', refresh);
    const timer = window.setInterval(refresh, 30000);
    return () => {active = false; window.clearInterval(timer); window.removeEventListener('focus', refresh); window.removeEventListener('tps:data-changed', refresh); document.removeEventListener('visibilitychange', refresh);};
  }, [scope]);
  return <ArtistTasksContext.Provider value={scope && state.scope === scope ? state : empty}>{children}</ArtistTasksContext.Provider>;
}

export function ArtistTaskBadge() {
  const {items, error, loading} = useArtistTasks();
  if (loading || error || !items.length) return null;
  return <span className="ml-auto rounded border border-primary/30 bg-primary/10 px-1.5 text-[10px] font-semibold text-primary" aria-label={tr('{{0}} consensi da completare', {0: items.length})}>{items.length}</span>;
}
